// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import Text from 'crehana-ui/Text';
import { yellowMain } from 'crehana-ui/styles/colors';
import useCountdown from 'Jsx/Shared/Hooks/useCountdown';

const Container = styled.div`
  box-sizing: border-box;
`;

const PromoCountdownBar: React.FC<{
  message: string;
  alternativeShortMessage: string;
  handleClickOnCountdownBar?(): void;
  expirationDate: Date;
}> = ({
  message,
  alternativeShortMessage,
  handleClickOnCountdownBar,
  expirationDate,
}) => {
  const {
    rawDays,
    hours,
    minutes,
    seconds,
    hasStarted,
    finished,
  } = useCountdown(expirationDate);

  return (
    <React.Fragment>
      {hasStarted && !finished && (
        <Container
          className="bg-base-dark relative z-1 flex items-center justify-center py-12 lg:py-0 lg:h-64 w-full cursor-pointer"
          onClick={() => {
            if (handleClickOnCountdownBar) {
              handleClickOnCountdownBar();
            }
          }}
        >
          <Text
            className="text-center tw-font-semibold"
            color="white"
            responsive="sm"
            type="subtitle3"
            as="p"
          >
            <span className="hidden sm:inline-flex mr-8">{message}</span>
            <span className="inline-flex sm:hidden">
              {alternativeShortMessage}
            </span>
            <span className="block sm:inline" style={{ color: yellowMain }}>
              {`${rawDays}D - ${hours}h : ${minutes}m : ${seconds}s`}
            </span>
          </Text>
        </Container>
      )}
    </React.Fragment>
  );
};

export default PromoCountdownBar;
